<template
  ><div class="v-dialog-windows-sequence">
    <div class="v-dialog-windows-sequence__heading">
      <span class="back"
        ><img
          v-show="pages && currentPage !== 1"
          :src="backArrow"
          alt="back"
          @click="previousSequencePage"
      /></span>
      <div class="title">{{ orderedPages[currentPage - 1].title }}</div>
      <div v-if="pages" class="slider-dots">
        <span
          v-for="page in orderedPages"
          class="dot"
          :class="dotClass(page.pageNumber)"
          @click="() => onDotClickHandler(page.pageNumber)"
        >
        </span>
      </div>
    </div>

    <div class="v-dialog-windows-sequence__content">
      <div class="description">
        {{ orderedPages[currentPage - 1].description }}
      </div>
      <div class="form-wrapper">
        <component
          :is="orderedPages[currentPage - 1].component"
          v-bind="orderedPages[currentPage - 1].props"
        ></component>
      </div>
    </div></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import orderBy from "lodash/orderBy";

import withFormUtils from "@/mixins/withFormUtils";
import backArrow from "@/assets/images/arrow-left.svg";

import withDialogWindowsSequence from "@/mixins/withDialogWindowsSequence";

export default Vue.component("VDialogWindowsSequence", {
  props: {
    pages: VueTypes.arrayOf(
      VueTypes.shape({
        title: VueTypes.string,
        description: VueTypes.string,
        component: VueTypes.any,
        props: VueTypes.any
      })
    )
  },

  mixins: [withFormUtils, withDialogWindowsSequence],

  data() {
    return {
      backArrow,
      lsLastCompletedPage: 0,
      orderedPages: orderBy(this.pages, "pageNumber")
    };
  },

  methods: {
    _setLastCompletedPage() {
      this.lsLastCompletedPage =
        Number(localStorage.getItem("lastCompletedPage")) || 0;
    },

    onDotClickHandler(pageNumber) {
      if (
        (this.lsLastCompletedPage &&
          this.lsLastCompletedPage + 1 >= this.currentPage &&
          this.lsLastCompletedPage + 1 >= pageNumber) ||
        this.dotClass(pageNumber) === "completed"
      ) {
        this.setSequencePage(pageNumber, false);
      }
    },

    dotClass(pageNumber) {
      let cls;

      if (pageNumber === this.currentPage) {
        cls = "current";
      } else if (pageNumber <= this.lsLastCompletedPage) {
        cls = "completed";
      } else if (
        this.lsLastCompletedPage &&
        this.lsLastCompletedPage + 1 === pageNumber
      ) {
        cls = "pending";
      }

      return cls;
    }
  },

  mounted() {
    this._setLastCompletedPage();
    if (localStorage.getItem("lastCompletedPage")) {
      this.setSequencePage(this.lsLastCompletedPage + 1, false);
    }
  },

  watch: {
    currentPage: function() {
      this._setLastCompletedPage();
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-dialog-windows-sequence";

.#{$ns} {
  color: $main-text-color;
  width: 430px;
  min-height: 571px;
  padding: 60px 20px;
  display: grid;
  grid-template-rows: auto 1fr;
  justify-content: center;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  .#{$ns}__heading {
    font-size: 18px;
    line-height: 22px;
    width: 100%;
    display: grid;
    grid-template-columns: 17px 1fr auto;
    grid-gap: 14px;
    align-items: center;
    margin-bottom: 15px;

    .back {
      img {
        cursor: pointer;
      }
    }

    .title {
      font-family: "Lato-Bold", Arial, sans-serif;
    }

    .slider-dots {
      display: flex;
      align-items: center;
      .dot {
        display: inline-block;
        margin-right: 10px;
        background-color: $primary-grey;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }

      .pending {
        background-color: $warning-color;
        cursor: pointer;
      }

      .current {
        width: 12px;
        height: 12px;
        background-color: $main-text-color;
      }

      .completed {
        background-color: $primary-color;
        cursor: pointer;
      }

      :last-child {
        margin-right: 0;
      }
    }
  }

  .#{$ns}__content {
    padding: 0 30px;
    display: grid;
    grid-template-rows: auto 1fr;
    .description {
      font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
      font-size: 14px;
      line-height: 1.5;
      letter-spacing: 0.175px;
      margin-bottom: 30px;
    }
  }
}

.v-dialog-windows-sequence /deep/ .btn-wrapper button {
  min-width: 330px;
}
.v-dialog-windows-sequence /deep/ .form-wrapper {
  .email-wrapper,
  .field-wrapper {
    margin-bottom: 42px;
  }
}
</style>
